
function TopBanner(props) {
    return (
        <div>
            <div className='mt-5'></div>
            <div className="jumbotron jumbotron-fluid">
                <div className="container">


                    <div className="row">
                        <div className="col-md-6 vertical-spacing-sm column-centering">
                            <div>
                                <div className="vertical-align-text" id="panel2">
                                    <div>
                                        {props.children}
                                    </div>
                                </div>

                            </div>

                        </div>

                    </div>
                    <div style={{ position: 'relative' }}>
                        <div className='absolute bauhaus-container'>
                            <div className='row no-shrink'>
                                <div className='col nopadding no-shrink'><div className='semicircle' /></div>
                                <div className='col nopadding no-shrink'><div className='semicircle blue-bg-2 bleft-circle' /></div>
                                <div className='col nopadding no-shrink'><div className='semicircle black-bg-2 bright-circle' /></div>
                                <div className='col nopadding no-shrink'><div className='semicircle orange-bg-2 tleft-circle' /></div>
                                <div className='col nopadding no-shrink'><div className='semicircle blue-bg-2 bleft-circle' /></div>
                                <div className='col nopadding no-shrink'><div className='semicircle white-bg bright-circle' /></div>
                                <div className='col nopadding no-shrink'><div className='semicircle orange-bg-2 tleft-circle' /></div>
                                <div className='col nopadding no-shrink'><div className='semicircle black-bg tright-circle' /></div>
                                <div className='col nopadding no-shrink'><div className='semicircle white-bg bright-circle' /></div>
                                <div className='col nopadding no-shrink'><div className='semicircle' /></div>
                                <div className='col nopadding no-shrink'><div className='semicircle' /></div>
                            </div>
                            <div className='row no-shrink'>
                                <div className='col nopadding no-shrink'><div className='semicircle white-bg tright-circle' /></div>
                                <div className='col nopadding no-shrink'><div className='semicircle blue-bg-2 bleft-circle' /></div>
                                <div className='col nopadding no-shrink'><div className='semicircle blue-bg-2 bleft-circle' /></div>
                                <div className='col nopadding no-shrink'><div className='semicircle blue-bg-2 bleft-circle' /></div>
                                <div className='col nopadding no-shrink'><div className='semicircle blue-bg-2 bleft-circle' /></div>
                                <div className='col nopadding no-shrink'><div className='semicircle black-bg tleft-circle' /></div>
                                <div className='col nopadding no-shrink'><div className='semicircle black-bg bleft-circle' /></div>
                                <div className='col nopadding no-shrink'><div className='semicircle blue-bg-2 tright-circle' /></div>
                                <div className='col nopadding no-shrink'><div className='semicircle orange-bg-2 tleft-circle' /></div>
                                <div className='col nopadding no-shrink'><div className='semicircle blue-bg-2 bleft-circle' /></div>
                                <div className='col nopadding no-shrink'><div className='semicircle' /></div>
                            </div>
                            <div className='row no-shrink'>
                                <div className='col nopadding no-shrink'><div className='semicircle blue-bg-2 bleft-circle' /></div>
                                <div className='col nopadding no-shrink'><div className='semicircle black-bg bleft-circle' /></div>
                                <div className='col nopadding no-shrink'><div className='semicircle white-bg tleft-circle' /></div>
                                <div className='col nopadding no-shrink'><div className='semicircle blue-bg-2 tright-circle' /></div>
                                <div className='col nopadding no-shrink'><div className='semicircle' /></div>
                                <div className='col nopadding no-shrink'><div className='semicircle orange-bg-2 bleft-circle' /></div>
                                <div className='col nopadding no-shrink'></div>
                                <div className='col nopadding no-shrink'><div className='semicircle blue-bg-2 bleft-circle' /></div>
                                <div className='col nopadding no-shrink'><div className='semicircle white-bg bright-circle' /></div>
                                <div className='col nopadding no-shrink'><div className='semicircle black-bg tleft-circle' /></div>
                                <div className='col nopadding no-shrink'><div className='semicircle orange-bg-2 bright-circle' /></div>
                            </div>
                        </div>


                    </div>
                </div>
            </div>
        </div>
    )
}

export default TopBanner;